import { formatCurrency } from "helpers/currency";
import Card from "../ui/Card";
import { useInvestmentAmount } from "./hooks";
import {
  CardContent,
  ClientFundFieldWrapper,
  ClientFundInput,
  ErrorMessage,
  FieldWrapper,
  HelpTooltip,
  InlineLabel,
  Label,
  NetAllocationInfo,
  NetAllocationInput,
  Summary,
  Total,
} from "./styles";

const InvestmentAmountCard = ({ props }: any) => {
  const {
    clientFunds,
    updateClientFunds,
    netAllocation,
    updateNetAllocation,
    investmentAmount,
    isInvestmentOrBondProduct,
    investmentAmountCardDisabled,
    errors,
    logTooltipAnalyticsEvent,
  } = useInvestmentAmount();

  return (
    <Card
      title="Investment amount"
      disabled={investmentAmountCardDisabled}
      {...props}
    >
      <CardContent>
        <ClientFundFieldWrapper>
          <InlineLabel>Investment premium (gross)</InlineLabel>

          <ClientFundInput
            prefix="&euro;"
            maxLength={8}
            decimals={0}
            value={clientFunds}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              updateClientFunds(e.target.value);
            }}
          />
        </ClientFundFieldWrapper>

        <FieldWrapper>
          <InlineLabel>Net allocation</InlineLabel>

          <NetAllocationInput
            name="netAllocation"
            suffix="%"
            maxLength={6}
            decimals={2}
            value={netAllocation}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              updateNetAllocation(e.target.value);
            }}
            validationRules={{ required: true, min: 92, max: 105 }}
          />

          <HelpTooltip onClick={logTooltipAnalyticsEvent}>
            Percentage of the investment premium that will be allocated to the
            policy after deducting initial commission and where relevant, the 1%
            government levy
          </HelpTooltip>
        </FieldWrapper>

        {errors.netAllocation && (
          <ErrorMessage>
            The net allocation must be between 92% and 105%
          </ErrorMessage>
        )}

        <Summary>
          <Label>Investment premium (net)</Label>

          <Total>&euro;{formatCurrency(investmentAmount)}</Total>
        </Summary>

        {isInvestmentOrBondProduct && (
          <NetAllocationInfo>
            <strong>Life Assurance Premium Levy:</strong> A 1% government levy
            applies to all investment products sold in Ireland. Remember to
            factor this in when calculating the net allocation.
          </NetAllocationInfo>
        )}
      </CardContent>
    </Card>
  );
};
export default InvestmentAmountCard;
